import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { EmailConfirmStatus, NavStep, Stage, UserModel } from '../../../../shared/services/forge-rock.interface';
import { AbstractRegistrationJourneyComponent } from '../../../abstract-journey/abstract-registration-journey.component';

@Component({
  selector: 'client-registration',
  templateUrl: './client-registration.component.html',
  styleUrls: ['./client-registration.component.css']
})
export class ClientRegistrationComponent extends AbstractRegistrationJourneyComponent {
 
  otpSubmitted = false;
  verificationComplete = false;  

  @ViewChild('otpSubButton') otpSubButton !: ElementRef;
 
  steps :NavStep[] = [{'stage':Stage.TOU,'navText':'Accept Terms Of Use'},
                      {'stage':Stage.USER_CREATION,'navText':'Register Account'}];

  override getNextNavStep(stage ?:Stage) {
    let nextStage =  this.nextStage;
    switch (this.nextStage) {
      case Stage.USERNAME:
      case Stage.PASSWORD:
      case Stage.EMAIL_SENT: 
            nextStage = Stage.USER_CREATION;
            break;
      case Stage.OTP_METHOD:
      case Stage.OTP_RESEND:
      case Stage.OTP: 
            nextStage = Stage.OTP;
            break;  
      default: nextStage = this.nextStage;
    }
     return nextStage? this.steps.find((s)=>s.stage == nextStage) : undefined;
  } 


  protected setOtpChoice(ngForm: NgForm, choiceResp:any, stage:Stage) {
    this.otpChoice = choiceResp;
    ngForm.ngSubmit.emit();
  }


  override onStepComplete(currentStage:Stage) {
    if (this.hasStepCompleted(currentStage)) {
        this.active = this.getNextNavStep(currentStage)?.stage.toString();
        if (this.nextStage == Stage.LOGIN_REDIRECT) {
          this.confirmSuccess(EmailConfirmStatus.REGISTERED_EMAIL);
        }
        if (this.registered) {
          if (this.nextStage == Stage.EMAIL_SENT) {
            this.sentVerificattionCode = true;
            this.hasStepResponse({},this.nextStage); //acknowledge message received to IDP
          }else{
            this.confirmSuccess(this.sentVerificattionCode ? EmailConfirmStatus.VERIFICATION_CODE_SENT: EmailConfirmStatus.REGISTRATION_SUCCESS);
          }
        }
    }
  }

  onVerificationSubmit(ngForm : NgForm) { 
      this.showErrors();
      if (ngForm.invalid) {
        return;
      }

      let formdata = ngForm.form.value;
      let credentials : UserModel = {} as UserModel;
      credentials.password = formdata.onetimePassword?.trim();
      credentials.otpChoice = this.otpChoice;
 
      this.handleResendCode('reject').then((resp) => {
        this.otpSubmitted = true
        if (this.nextStage) {
          this.hasStepResponse(credentials,this.nextStage); 
        }
        this.otpSubmitted = false;
        },(err)=>{
          this.otpSubmitted = false;
        });
  }

  override unlockedStage(stage:Stage) {
    switch (stage) {
      case Stage.TOU: return true;
      case Stage.USER_CREATION: return this.userService.touAccepted;
      case Stage.EMAIL_SENT: return this.registered;
    }
    return false;
  }

  override hasStepCompleted(stage:Stage) {
    //console.log('hasStepCompleted', stage, this.userService.touAccepted, this.sentVerificattionCode, this.otpVerificationComplete);
    switch (stage) {
      case Stage.TOU: return this.userService.touAccepted;
      //case Stage.USER_IDENTITY: return this.userService.identityVerified;
      case Stage.VERIFIED_EMAIL: return this.userService.emailConfirmed;
      case Stage.USER_CREATION: this.registered = this.userService.registered; return this.userService.registered;
      case Stage.EMAIL_SENT: return this.sentVerificattionCode;
    }
    return false;
  }

}
